<script>
  import { planets, planetIndex, planetInfoFlag } from "../js/stores.js"
  import { slide, fade } from "svelte/transition"
  import { _, json } from "svelte-i18n"

  import { clickOutside } from "../js/clickOutside.js"

  $: if ($planetInfoFlag) {
    setTimeout(() => {
      console.log("planet-" + ($planetIndex - 1))
      let target = document.getElementById("planet-" + ($planetIndex - 1))
      target.parentNode.scrollTop = target.offsetTop
    }, 500)
  }
</script>

{#if $planetInfoFlag}
  <div
    class="container"
    transition:fade
    use:clickOutside
    on:click_outside={() => {
      $planetInfoFlag = false
    }}
  >
    {#each $planets as planet, i}
      <div
        id="planet-{i}"
        class="planet-panel"
        class:active={$planetIndex - 1 == i}
        class:hidden={$planetIndex - 1 < i}
      >
        <!-- <div class="planet-container"> -->
        <img src={planet} alt="" class="planet" />
        <!-- </div> -->
        <div class="name">
          {$json("planetNames")[i]}
        </div>
        <div class="info">
          {$json("planetInfo")[i]}
        </div>
      </div>
    {/each}
  </div>
{/if}

<style>
  .container {
    background: rgba(0, 0, 0, 1);
    color: rgba(255, 255, 255, 0.8);

    display: grid;
    grid-template-columns: repeat(7, 1fr);

    position: absolute;
    top: 63px;
    z-index: 1000;
    gap: 10px;
    padding: 20px;

    scroll-behavior: smooth;
  }

  .planet-panel {
    /* display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center; */

    display: grid;
    grid-template-columns: auto;
    grid-template-rows: 200px 10px auto;

    /* grid-auto-rows: 1fr; */

    /* align-items: start; */
    justify-items: center;

    gap: 20px;
    opacity: 0.35;
    padding: 20px;

    border-radius: 20px;
  }

  .planet-panel:hover,
  .active {
    opacity: 1;
    background: rgba(255, 255, 255, 0.1);
  }

  .planet-panel.hidden div.info {
    /* border: 1px solid lightgreen; */
    visibility: hidden;
  }

  /* .active {
    opacity: 1;
  } */

  .name {
    font-weight: bold;
    align-self: start;
  }

  .info {
    text-align: center;
    align-self: start;
    padding-top: 5px;
  }

  .planet-container {
    /* width: 100%;
    height: 100%; */
  }

  .planet {
    /* width: 100%;
    display: block; */
    height: 100%;
    width: 100%;
    /* transform: rotate(70deg); */
  }

  @media (max-width: 1200px) {
    .container {
      /* gap: 10px;
      padding: 10px; */
      /* grid-template-columns: auto;
      grid-template-rows: 180px 10px auto; */
    }
  }

  @media (max-width: 1200px) {
    .container {
      grid-template-columns: 1fr;
      grid-template-rows: repeat(7, 1fr);
      grid-auto-flow: column;
      gap: 0px;
      padding: 0px;
      top: 52px;
      height: calc(100vh - 52px);

      max-width: 600px;

      overflow-y: scroll;
    }

    /* .planet-container {
      align-content: start;
    } */

    .planet-panel {
      /* grid-auto-flow: column; */

      grid-template-areas:
        "a b"
        "a c";
      grid-template-columns: 100px auto;
      grid-template-rows: auto auto;

      /* grid-auto-rows: auto; */
      justify-items: start;
      align-items: start;

      padding: 20px;
      gap: 0px;

      border-radius: 0;
    }

    .info {
      text-align: left;
    }

    .planet-panel div {
      /* border: 1px solid lightgreen; */
      padding-left: 20px;
      font-size: 1rem;
    }

    .name {
      align-self: end;
    }

    .info {
      align-self: start;
    }

    .planet {
      grid-area: a;
      height: 100%;
      width: 100%;
    }
  }

  /* @media (max-height: 823px) and (max-width: 1000px) {
    .planet-panel {
      grid-template-columns: 60px auto;
    }

    .planet-panel div {
      padding-left: 20px;
      font-size: 0.7rem;
    }
  } */
</style>
